export const UrlFragments = {
  match: {
    byId: ':id',
    byTab: ':tab',
  },
  user: {
    all_users: 'users',
    user: 'user',
    segments: 'segments',
    metadata_types: 'metadata_types',
    resetPwd: 'resetpassword',
    roles: 'roles',
    user_company: 'company',
  },
  login: 'login',
  unauthorised: 'unauthorised',
  portfolio: {
    all_pfs: 'portfolios',
    owner: 'owner',
  },
  subscription: {
    all_subscription: 'subscriptions',
    subscription: 'subscription',
    create_subscription: 'create-subscription',
    addons: 'addons',
    plans: 'plans',
  },
  tabs: {
    userDetail: 'user-detail',
    portfolios: 'portfolios',
    subscriptionDetail: 'subscription-details',
  },
  overview: 'overview',
  stats: 'stats',
  company: {
    all_companies: 'companies',
    company: 'company',
    sso_connection_type: 'sso-connections',
    upload_sso_config: 'upload-sso-config',
    download_sso_config: 'download-sso-config',
    create_company: 'create-company',
  },
};

const {
  user: { user, all_users },
  tabs: { userDetail, portfolios, subscriptionDetail },
  subscription: { subscription, create_subscription, all_subscription },
  portfolio: { all_pfs },
  company: { all_companies, company, create_company },
} = UrlFragments;

export const UrlToUser = (user_id?: string) => ({
  all_users: `/${all_users}`,
  detail: `/${user}/${user_id}/${userDetail}`,
  pfs: `/${user}/${user_id}/${portfolios}`,
  createSub: `/${user}/${user_id}/${create_subscription}`,
});

export const UrlToSubscription = (sub_id?: string) => ({
  all_subs: `/${all_subscription}`,
  detail: `/${subscription}/${sub_id}/${subscriptionDetail}`,
  pfs: `/${subscription}/${sub_id}/${all_pfs}`,
  create: `/${create_subscription}`,
});

export const UrlToPortfolio = (pf_id?: string) => ({
  all_pfs: `${all_pfs}`,
});

export const UrlToCompany = (company_id?: string) => ({
  all_companies: `/${all_companies}`,
  detail: `/${company}/${company_id}`,
  create: `/${create_company}`,
});

export enum SupportedLocaleList {
  enAU = 'en-AU',
  enGB = 'en-GB',
  enUS = 'en-US',
  zhCN = 'zh-CN',
}

export enum SupportedSegmentList {
  assetic = 'assetic',
  dsi = 'dsi',
  canada = 'canada',
}
